import React, { createContext, useContext, useState, ReactNode } from 'react'

interface BlurContextType {
  isBlurred: boolean
  setBlurred: (blurred: boolean) => void
}

const BlurContext = createContext<BlurContextType | undefined>(undefined)

export const useBlurContext = () => {
  const context = useContext(BlurContext)
  if (context === undefined) {
    throw new Error('useBlurContext must be used within a BlurProvider')
  }
  return context
}

interface BlurProviderProps {
  children: ReactNode
}

export const BlurProvider: React.FC<BlurProviderProps> = ({ children }) => {
  const [isBlurred, setIsBlurred] = useState(false)

  const setBlurred = (blurred: boolean) => {
    setIsBlurred(blurred)
  }

  return (
    <BlurContext.Provider value={{ isBlurred, setBlurred }}>
      {children}
    </BlurContext.Provider>
  )
} 